import { render, staticRenderFns } from "./NavBrand.vue?vue&type=template&id=a4c4cd2a&scoped=true&"
import script from "./NavBrand.vue?vue&type=script&lang=js&"
export * from "./NavBrand.vue?vue&type=script&lang=js&"
import style0 from "./NavBrand.vue?vue&type=style&index=0&id=a4c4cd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c4cd2a",
  null
  
)

export default component.exports